import { createAction } from 'redux-actions';
import { fetchJson } from 'utils/fetch';

export const fetchFormAction = createAction('FETCH_FORM');
export const fetchFormSuccessAction = createAction('FETCH_FORM_SUCCESS');
export const updateDataAction = createAction('UPDATE_FIELD');
export const refreshErrorsAction = createAction('REFRESH_ERRORS');
export const cleanErrorsAction = createAction('CLEAN_ERRORS');

export const fetchForm = caseId => (dispatch, getState) => {
  const state = getState();
  if (state.form.isFetching) {
    return Promise.resolve();
  }

  dispatch(fetchFormAction());

  if (caseId) {
    return fetchJson(`/pco-manager/aast/cases/${caseId}/study.json`).then(
      response => {
        dispatch(fetchFormSuccessAction(response));
      }
    );
  } else {
    return dispatch(fetchFormSuccessAction({}));
  }
};

export const updateData = (propName, propValue) => (dispatch, getState) => {
  dispatch(updateDataAction({ propName, propValue }));
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/actions/form.js